export const UPCOMING_GROUP_LESSON_LOAD_COUNT = 2;
